interface FilterGroup {
  key: string;
  label: string;
  options: string[];
}

interface FilterBarProps {
  groups: FilterGroup[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
  onReset: () => void;
  hasActiveFilter: boolean;
}

export default function FilterBar({
  groups,
  values,
  onChange,
  onReset,
  hasActiveFilter,
}: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-4">
        {groups.map((group) => (
          <div key={group.key} className="flex flex-col gap-2 sm:flex-row sm:items-start">
            <span className="shrink-0 pt-1 text-sm font-medium text-secondary-600 sm:w-16">
              {group.label}
            </span>
            <div className="flex flex-wrap gap-2">
              {group.options.map((option) => {
                const active = values[group.key] === option;
                return (
                  <button
                    key={option}
                    type="button"
                    onClick={() => onChange(group.key, option)}
                    className={`whitespace-nowrap rounded-md px-3 py-1.5 text-sm transition-colors ${
                      active
                        ? "bg-primary-500 font-medium text-background-50"
                        : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
                    }`}
                  >
                    {option}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      {hasActiveFilter && (
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
          <span className="text-xs text-secondary-500">已应用筛选条件</span>
          <button
            type="button"
            onClick={onReset}
            className="flex items-center gap-1 whitespace-nowrap rounded-md px-2.5 py-1 text-sm text-accent-600 transition-colors hover:bg-accent-50"
          >
            <i className="ri-close-circle-line"></i>
            清空筛选
          </button>
        </div>
      )}
    </div>
  );
}